import styled from 'styled-components';
import { media } from '../../utilities/style-utilities';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  width: 100%; 
  max-width: 600px;

  /* @media (max-width: 600px) {
    flex-direction: column;
    max-width: unset;
  } */

  ${ media.mobile`
    font-size: 0.9em;
  `}

  ${ media.handheld`
    flex-direction: column;
    max-width: unset;
  `}
`;

export default ButtonWrapper;


// WEBPACK FOOTER //
// ./src/components/Form/ButtonWrapper.js